import React, { Fragment } from "react";
import Loader from "../../App/layout/Loader";
import { connect } from "react-redux";

function PageLoaderContainer(props) {
  return <Fragment>{props.pageLoading && <Loader />}</Fragment>;
}

function mapStateToProps(state) {
  return {
    pageLoading: state.globalData.isLoading
  };
}

export default connect(mapStateToProps)(PageLoaderContainer);
